import { SAVE_USER } from "../constants/actionTypes";

const users = (state = {}, action) => {
  switch (action.type) {
    case SAVE_USER:
      return {
        ...state,
        [action.id]: action.data
      };
    default:
      return state;
  }
};

export default users;
